export const ONE_TO_ONE_CSOD_TEST_PORTAL_1_CY_DATA = "one-to-one-csod-test-portal-1"
export const ONE_TO_ONE_CSOD_TEST_PORTAL_2_CY_DATA = "one-to-one-csod-test-portal-2"
export const ONE_TO_MANY_CSOD_TEST_PORTAL_CY_DATA = "one-to-many-csod-test-portal"
export const ONE_TO_MANY_SABA_TEST_PORTAL_CY_DATA = "one-to-many-saba-test-portal"
